var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.353 100.353",
    style: {
      enableBackground: "new 0 0 100.353 100.353"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M83.873,4.861H16.131c-6.07,0-11.009,4.939-11.009,11.009v46.622 c0,6.069,4.938,11.007,11.009,11.007h24.068v18.64H21.544c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h20.155h16.605h20.155 c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H59.804v-18.64h24.068c6.068,0,11.005-4.938,11.005-11.007V15.87 C94.878,9.8,89.941,4.861,83.873,4.861z M16.131,7.861h67.742c4.414,0,8.005,3.593,8.005,8.009v35.35H8.123V15.87 C8.123,11.453,11.715,7.861,16.131,7.861z M56.805,92.139H43.2v-18.64h13.605V92.139z M83.873,70.499H58.305H41.7H16.132 c-4.416,0-8.009-3.592-8.009-8.007v-8.271h83.755v8.271C91.878,66.907,88.287,70.499,83.873,70.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M50.002,57.055c-3.097,0-5.616,2.518-5.616,5.612s2.519,5.612,5.616,5.612 c3.095,0,5.612-2.518,5.612-5.612C55.614,59.573,53.097,57.055,50.002,57.055z M50.002,65.279c-1.442,0-2.616-1.172-2.616-2.612 s1.173-2.612,2.616-2.612c1.44,0,2.612,1.172,2.612,2.612S51.442,65.279,50.002,65.279z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.2c1729f7613de9643e3cb1a0e30b2520.svg";
export { ForwardRef as ReactComponent };